import React from 'react';
import styled from 'styled-components';
import MuiDialog from 'material-ui/Dialog';

const BaseDialog = ({ className, ...props }) => <MuiDialog classes={{ paper: className }} {...props} />;

export default styled(BaseDialog)`
    && {
        border-top: 0.3em solid #297DFD;
        padding: 1.5em 2em;
        max-height: calc(100% - 96px);
        display: flex;
        overflow-y: auto;
    }
`;
